'use client'

import { useEffect, useState } from 'react'
import type { IAuthUser } from '../../interfaces'

export const useRoles = () => {
  const [authUser, setAuthUser] = useState<IAuthUser | null>(null)

  const roles = authUser?.roles

  const isAdminAgency = Boolean(roles?.AGENCY)

  const isAdvance = Boolean(roles?.ADVANCED)

  const isBasicUser = Boolean(
    roles?.BASIC && !roles?.BROKER && !roles?.AGENCY && !roles.AGENCY_BROKER
  )

  const isBrokerWithAgency = Boolean(
    roles?.BROKER && roles?.AGENCY_BROKER && !roles?.AGENCY
  )

  const isIndependentAgent = Boolean(roles?.BROKER && !roles?.AGENCY_BROKER)

  const isDeveloper = Boolean(
    !roles?.DEVELOPER_USER && (roles?.DEVELOPER || roles?.ROLE_ADMIN_DEVELOPER)
  )

  const rolesExist = Boolean(roles && Object.keys(roles)?.length > 0)

  const userIsNotFree = Boolean(
    rolesExist &&
      (roles?.PRIME || roles?.PRO || roles?.STARTER || roles?.ADVANCED)
  )

  const isNotAgency = Boolean(
    rolesExist && !roles?.AGENCY && !roles?.AGENCY_BROKER
  )

  const userIsFree = Boolean(
    rolesExist &&
      !roles?.PRIME &&
      !roles?.PRO &&
      !roles?.STARTER &&
      !roles?.ADVANCED
  )

  const userHasPlan = Boolean(
    rolesExist &&
      (roles?.PRIME || roles?.PRO || roles?.STARTER || roles?.ADVANCED)
  )

  const isAssociation = Boolean(rolesExist && roles?.ASSOCIATION)

  useEffect(() => {
    const init = async () => {
      const { getCookieAuthUser } = await import('../services')
      const cookieAuthUser = getCookieAuthUser()
      setAuthUser(cookieAuthUser)
    }

    init()
  }, [])

  return {
    roles,
    isIndependentAgent,
    isBasicUser,
    isAdminAgency,
    isBrokerWithAgency,
    isDeveloper,
    rolesExist,
    userIsNotFree,
    userIsFree,
    isNotAgency,
    isAdvance,
    userHasPlan,
    isAssociation
  }
}

export default useRoles
